module.exports = __webpack_public_path__ + "img/productionBase_10.66ff9bed.png";